import heroimg from "../../../../../images/LandingPageImage/mn_audience_tracking.webp";
import "../../styles/LandingPageCss/MainHomeSection.css";
import FAQContactSection from "../LandingPagecomponents/FAQContactSection";
import google from "../../../../../images/LandingPageImage/google.png";
import { useModal } from "../../../../../MyContext";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";

export default function AudienceTargeting() {
  const { openModal } = useModal();
  return (
    <div>
      <Navbar />
      <section className="hero-section py-5 py-md-5 font-inter">
        <div className="container px-3 px-lg-4">
          <div className="row align-items-center gx-lg-5 gy-5">
            <div className="col-12 col-md-6 order-2 order-md-1">
              <div className="hero-content text-center text-md-start">
                <h1 className="hero-title text-purple font-spacegrotesk fw-semibold">
                  Audience Segmentation: Target the Right Customers on WhatsApp
                </h1>

                <p className="hero-subtitle mt-3">
                  In contemporary digital marketing, it is no longer the target
                  to approach everyone but rather the correct audience. This is
                  because successful audience targeting enables companies to
                  provide customer-specific messages to particular groups of
                  customers and hence an increase in engagements, improved
                  conversions, and increased ROI. As WhatsApp has become the
                  most popular means of communication, intelligent targeting has
                  become a key to business development.
                </p>

                <div className="d-flex gap-3 mt-4 justify-content-center justify-content-lg-start flex-wrap">
                  <Link
                    to="/login"
                    className="btn d-flex align-items-center text-decoration-none bg-neon-purple rounded-1 text-white justify-content-center gap-2 home-btn-primary fw-medium hover-scale"
                  >
                    <span
                      className="rounded-circle bg-white d-flex align-items-center justify-content-center flex-shrink-0"
                      style={{ width: "30px", height: "30px" }}
                    >
                      <img
                        src={google}
                        alt="Google"
                        style={{ width: "20px", height: "20px" }}
                        className="img-fluid"
                      />
                    </span>

                    <span className="text-nowrap fs-6">Start With Google</span>
                  </Link>
                  <button
                    onClick={openModal}
                    className="btn d-flex align-items-center justify-content-center bg-white rounded-1   home-btn-secondary fw-medium"
                  >
                    <span className="text-nowrap fs-5">Book a Demo</span>
                  </button>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 order-2 order-md-2">
              <div className="hero-image-wrapper d-flex justify-content-center align-items-center">
                <div className="hero-circle-bg">
                  <div className="circle-element "></div>
                  <img
                    src={heroimg}
                    alt="WhatsApp marketing dashboard"
                    className="hero-img img-fluid  rounded-4"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about-section font-inter text-center text-white d-flex align-items-center">
        <div className="container">
          <h1 className="new-section-title font-spacegrotesk">
            WhatsApp Marketing: What Is
            <br />
            Audience Targeting?
          </h1>

          <p className="about-text text-dark mb-5">
            Audience targeting is the act of dividing the customers using their
            characteristics like demographics, behavior, purchase history,
            interests and level of engagement. The businesses will find it
            easier to send customized communication, which will appeal to
            certain user groups, instead of sending the same message to
            everybody.
          </p>
          <div className="row g-4 justify-content-center">
            <div className="col-md-6">
              <div className="info-card text-start vision-card">
                <h3 className="text-dark font-spacegrotesk">
                  The importance of Audience Targeting to Business
                </h3>
                <p>
                  MsgNotifier helps businesses streamline and scale their
                  WhatsApp campaigns with ease. From seamless WhatsApp API
                  integration to bulk messaging, automation, and detailed
                  analytics, our platform ensures secure, compliant
                  communication with high delivery rates.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="info-card text-start  mission-card">
                <h3 className="font-spacegrotesk text-dark">
                  The way MsgNotifier makes possible advanced audience targeting
                </h3>
                <p>
                  MsgNotifier’s WhatsApp marketing software empowers businesses
                  to precisely identify, segment, and engage their target
                  audience at scale. With smart targeting, automated message
                  delivery, and real-time performance tracking, marketers can
                  run highly personalized and data-driven campaigns.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-section font-inter text-center text-white d-flex align-items-center">
        <div className="container">
          <h1 className="new-section-title font-spacegrotesk">
            Targeting of Audience to <br></br> various industries
          </h1>

          <p className="about-text text-dark mb-5">
            Targeting to the audience is effective in any industry and any size
            of business. Using whatsapp marketing software MsgNotifier, the
            businesses can tailor campaigns depending on industry requirements
          </p>

          <div className="row g-4 justify-content-center">
            <div className="col-md-6">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  Industry-Specific Audience Segmentation
                </h3>
                <p className="text-white">
                  WhatsApp marketing allows businesses across industries to
                  segment audiences based on behavior and intent. E-commerce
                  brands can target loyal customers, cart abandoners, and
                  seasonal shoppers, while education, real estate, healthcare,
                  and finance sectors can engage users through tailored
                  messaging that matches their specific needs.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  Personalized and Relevant Communication
                </h3>
                <p className="text-white">
                  Effective audience targeting focuses on relevance and
                  personalization. By addressing users by name, preferences, or
                  interests, businesses can create meaningful interactions that
                  increase engagement and trust without overwhelming customers
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  Best Practices for Smarter Targeting
                </h3>
                <p className="text-white">
                  Successful WhatsApp campaigns rely on permission-based
                  messaging, balanced communication frequency, and continuous
                  performance analysis. Following opt-in guidelines and
                  regularly optimizing audience data ensures higher delivery
                  rates, better responses, and compliance with WhatsApp
                  policies.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  WhatsApp Campaign Management
                </h3>
                <p className="text-white">
                  Run bulk messaging campaigns, promotional broadcasts, and
                  personalized outreach with high delivery and engagement rates.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FAQContactSection />
      <Footer />
    </div>
  );
}
